// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2qlxw","content":"styles_content__3K0KC","selectAll":"styles_selectAll__2GteA"};